import React, { useState } from "react";
import Modal from "../shared/Modal";
import "./ModalDebugChat.css";
import { Button } from "../../ds2/components";
import { useSelector } from "react-redux";
import { selectLinkRecords, selectUser } from "../../redux/features/appData";
import { useParams } from "react-router-dom";
import { apiTestAction } from "../../services/AIService";
import { selectPersonas } from "../../redux/features/agent/agentSlice";
import { getStoreLinkRecord } from "winslow-core";
import { LinkRecordActivity } from "../shares/LinkRecordActivity";

interface ModalDebugChatProps {
  isOpen: boolean;
  onClose: () => void;
}

type ActionType =
  | "determine-personas"
  | "research-answer"
  | "clarify"
  | "general"
  | "process";

export const ModalDebugChat: React.FC<ModalDebugChatProps> = ({
  isOpen,
  onClose,
}) => {
  const [action, setAction] = useState<ActionType>("general");
  const [inputMessage, setInputMessage] = useState("");
  const [response, setResponse] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const storeUser = useSelector(selectUser);
  const { collectionId } = useParams();

  const personas = useSelector(selectPersonas);
  const linkRecords = useSelector(selectLinkRecords);

  const handleSubmit = async () => {
    if (!storeUser?.id || !collectionId) return;

    setIsLoading(true);
    try {
      const data = await apiTestAction({
        inputMessage,
        userId: storeUser.id,
        collectionId,
        action,
      });

      setResponse(data);
    } catch (error) {
      console.error("Error calling action:", error);
      setResponse({ error: "Failed to call action" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "800px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-debug-chat-container">
        <header className="modal-debug-chat-header">
          <h1 className="modal-debug-chat-title">Debug Chat</h1>
        </header>

        <div className="modal-debug-chat-content">
          <div className="modal-debug-chat-form">
            <div className="modal-debug-chat-form-group">
              <label htmlFor="action">Action:</label>
              <select
                id="action"
                value={action}
                onChange={(e) => setAction(e.target.value as ActionType)}
                className="modal-debug-chat-select">
                <option value="route-intent">Route Intent</option>
                <option value="determine-personas">Determine Personas</option>
                <option value="research-answer">Research Answer</option>
                <option value="clarify">Clarify</option>
                <option value="general">General</option>
                <option value="process">Process</option>
              </select>
            </div>

            <div className="modal-debug-chat-form-group">
              <label htmlFor="message">Input Message:</label>
              <textarea
                id="message"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                className="modal-debug-chat-textarea"
                placeholder="Enter your message..."
                rows={4}
              />
            </div>

            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isLoading || !inputMessage.trim()}>
              {isLoading ? "Loading..." : "Submit"}
            </Button>
            
            {/* <button
              className="modal-debug-chat-button-primary"
              onClick={handleSubmit}
              disabled={isLoading || !inputMessage.trim()}>
              {isLoading ? "Loading..." : "Submit"}
            </button> */}

            {response && (
              <div className="modal-debug-chat-response">
                <h3>Raw Response:</h3>
                <pre className="modal-debug-chat-response-content">
                  {JSON.stringify(response, null, 2)}
                </pre>
                {response?.sources &&
                  response.sources.length > 0 &&
                  response.sources.map((linkRecordId: string) => {
                    const linkRecord = getStoreLinkRecord(
                      linkRecordId,
                      linkRecords ?? []
                    );
                    if (!linkRecord) return null;

                    return (
                      <LinkRecordActivity
                        key={linkRecordId}
                        linkRecord={linkRecord}
                        minimum={true}
                        showDrag={false}
                        clickIsOpen={true}
                      />
                    );
                  })}
              </div>
            )}
          </div>
        </div>

        <footer className="modal-debug-chat-actions">
          <Button
            variant="secondary"
            onClick={onClose}
            type="button">
            Close
          </Button>
          
          {/* <button
            className="modal-debug-chat-button-secondary"
            onClick={onClose}
            type="button">
            Close
          </button> */}
        </footer>
      </div>
    </Modal>
  );
};
